import React, { useState } from "react";

import { ChevronRight } from "../Icons";

const CourseSuggestion = () => {
  const [showTooltip, toggleToolTip] = useState(false);

  return (
    <div className=" h-64 mx-4 md:mx-14 rounded-md my-14 bg-white flex flex-col justify-evenly text-center items-center text-2xl md:text-3xl p-4">
      <>
        Your favorite course not listed?
        <p className="text-base md:text-lg text-gray-700">
          Drop a suggestion and we'll add it!
        </p>
      </>
      <div className="relative">
        <form
          action="https://formsubmit.co/purnanshuborkaroffical@gmail.com"
          method="POST"
        >
          <div className="flex items-center border-2 border-gray-300 rounded-full overflow-hidden px-3">
            <input
              autoComplete="off"
              name="suggestion"
              placeholder=""
              type="text"
              className="outline-none text-center  p-2 text-lg min-w-max"
              onFocus={() => {
                toggleToolTip(true);
              }}
              onBlur={() => {
                toggleToolTip(false);
              }}
              onChange={(e) => {
                if (e.target.value === "") toggleToolTip(true);
                else toggleToolTip(false);
              }}
            />
            <button type="submit" className="text-gray-400">
              {" "}
              <ChevronRight />{" "}
            </button>
          </div>
          <div
            className={`bg-indigo-100 absolute top-full mt-3 shadow-sm sm:mt-0 left-1/2 transform -translate-x-1/2 sm:transform-none sm:left-full sm:ml-12 sm:-top-1/4 text-sm rounded-md p-3 w-44 transition-opacity text-center ${
              showTooltip ? "opacity-100" : "opacity-0"
            }`}
          >
            Make sure to add the platform!
          </div>
        </form>
      </div>
    </div>
  );
};

export default CourseSuggestion;
